import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../ui/Button/Button";
import { Checkbox } from "../../../../ui/Checkbox/Checkbox";
import { useTireCompareIds } from "../../TiresCompareDialog/useTireCompareIds";

type CompareButtonProps = {
  disabled: boolean;
  isCheckedForCompare: boolean;
  partId: string;
};

export const CompareButton: FunctionComponent<CompareButtonProps> = ({
  disabled,
  isCheckedForCompare,
  partId,
}) => {
  const { t } = useTranslation();
  const [, { toggle }] = useTireCompareIds();

  return (
    <Button
      aria-label="toggleTireCompare"
      className="tw-compare-button"
      disabled={disabled}
      element="label"
    >
      <Checkbox
        onChange={(): void => {
          toggle(partId);
        }}
        checked={isCheckedForCompare}
        disabled={disabled}
      />
      {t("dealerTireTile.compare")}
    </Button>
  );
};
